/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiAdminDtoSetLoginFailedCountDto
 */
export interface WebApiAdminDtoSetLoginFailedCountDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiAdminDtoSetLoginFailedCountDto
     */
    userId?: number;
    /**
     * 
     * @type {number}
     * @memberof WebApiAdminDtoSetLoginFailedCountDto
     */
    loginFailedCount?: number;
}

/**
 * Check if a given object implements the WebApiAdminDtoSetLoginFailedCountDto interface.
 */
export function instanceOfWebApiAdminDtoSetLoginFailedCountDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiAdminDtoSetLoginFailedCountDtoFromJSON(json: any): WebApiAdminDtoSetLoginFailedCountDto {
    return WebApiAdminDtoSetLoginFailedCountDtoFromJSONTyped(json, false);
}

export function WebApiAdminDtoSetLoginFailedCountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiAdminDtoSetLoginFailedCountDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'loginFailedCount': !exists(json, 'loginFailedCount') ? undefined : json['loginFailedCount'],
    };
}

export function WebApiAdminDtoSetLoginFailedCountDtoToJSON(value?: WebApiAdminDtoSetLoginFailedCountDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userId': value.userId,
        'loginFailedCount': value.loginFailedCount,
    };
}

